import { t } from 'i18next'

export enum CountryName {
    Thailand = 219,
    USA = 235,
    Ireland = 102,
    Australia = 14,
}

export function getSubRegionLabel(countryID?: number | null | undefined) {
    if (!countryID) return t('address.label.town_city')
    switch (countryID) {
        case CountryName.Thailand: {
            return t('address.label.sub_district')
        }
        case CountryName.USA:
        case CountryName.Australia: {
            return t('address.label.city')
        }
        case CountryName.Ireland: {
            return t('address.label.town_city')
        }
    }
}

export function getRegionLabel(countryID?: number | null | undefined) {
    if (!countryID) return t('address.label.province')
    switch (countryID) {
        case CountryName.Thailand: {
            return t('address.label.province')
        }
        case CountryName.USA: {
            return t('address.label.state')
        }
        case CountryName.Australia: {
            return t('address.label.state_territory')
        }
        case CountryName.Ireland: {
            return t('address.label.county')
        }
        default: {
            return t('address.label.province')
        }
    }
}

export function getPostalCode(countryID?: number | null | undefined) {
    if (!countryID) return t('address.label.postal_code.others')
    switch (countryID) {
        case CountryName.USA: {
            return t('address.label.postal_code.USA')
        }
        case CountryName.Australia:
        case CountryName.Thailand:
            return t('address.label.postal_code.others')
        case CountryName.Ireland: {
            return t('address.label.postal_code.Ireland')
        }
        default: {
            return t('address.label.postal_code.others')
        }
    }
}
